import signin from './signin'
import my from './my'
import store from './store'
import business from './business'
import signup from './signup'
import terms from './terms'
import product from './product'
import mall from './mall'
import wholesaler from './wholesaler'
import auth from './auth'
import bankAccount from './bankAccount'
import contract from './contract'
import news from './news'
import bnpl from './bnpl'
import choice from './choice'
import mallLimits from './mallLimits'
import fcm from './fcm'
import plans from './plans'
import bankMaintenance from './bankMaintenance'

export default {
  ...auth,
  ...bnpl,
  ...choice,
  ...fcm,
  ...news,
  ...signin,
  ...my,
  ...store,
  ...business,
  ...signup,
  ...terms,
  ...product,
  ...mall,
  ...wholesaler,
  ...bankAccount,
  ...contract,
  ...mallLimits,
  ...plans,
  ...bankMaintenance,
}
